<template>
  <div v-if="visible" class="project-controls">
    <!-- Page Paginator Section -->
    <div class="project-paginator">
      <button class="project-controls-arrow-left" @click="handlePageChange(-1)" :disabled="currentPageNumber <= 0"> </button>
      <span>{{ (currentPageNumber + 1) + "/" + projectPages.allowedPages.length }}</span>
      <button class="project-controls-arrow-right" @click="handlePageChange(+1)" :disabled="currentPageNumber >= projectPages.allowedPages.length - 1"> </button>
    </div>

    <!-- Add Page Button -->
    <el-tooltip
      v-if="!isPlanDiscovery && !isUserLimited"
      :popper-class="'custom-tooltip-popper'"
      :show-arrow="false"
      effect="light"
      :content="$t('template.addPage')"
      placement="bottom"
      class="item">
      <button class="project-controls-add-page" @click="handleAddProjectPage({ emptyPage: true })"></button>
    </el-tooltip>

    <!-- Duplicate Page Button -->
    <el-tooltip
      v-if="!isUserLimited"
      :popper-class="'custom-tooltip-popper'"
      :show-arrow="false"
      effect="light"
      :content="$t('template.duplicatePage')"
      placement="bottom"
      class="item">
      <button class="project-controls-duplicate-page" @click="handleAddProjectPage({ emptyPage: false })"></button>
    </el-tooltip>

    <!-- Overlay Page Button -->
    <template v-if="overlayProperties.isVisible && !isUserLimited">
      <el-tooltip
        :popper-class="'custom-tooltip-popper'"
        :show-arrow="false"
        effect="light"
        :content="$t('template.overlay')"
        placement="bottom"
        class="item">
        <button
          class="project-controls-add-overlay"
          :disabled="overlayProperties.isDisabled"
          @click="handleAddAppsOverlayClick"
        />
      </el-tooltip>
    </template>
  </div>
</template>
<script src="./project-template-controls.js"></script>
<style lang="scss" src="./project-template-controls.scss"></style>
